import React, { useState, useEffect } from 'react';
import ProductCard from './ProductCard';
import Header from '../Header';
import CategoryNav from '../CategoryNav';
import Footer from '../Footersection';
import Breadcrumb from './Breadcrumb';
import { Heart, ShoppingBag } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useNavigate } from "react-router-dom";
import { useWishlist } from '../../context/WishlistContext';
 
 
 
const Wishlist = () => {
  const navigate = useNavigate();
  const { addMultipleToCart } = useCart();
 
  const [wishlistItems, setWishlistItems] = useState([]);
  const [sortBy, setSortBy] = useState('newest');
  const { wishlist, clearwishlist } = useWishlist();
 
 
 
 
 
const handleAddAllToCart = () => {
  if (wishlistItems.length === 0) return;
 
  // Ensure quantity is set if your cart expects it
  const itemsToAdd = wishlistItems.map(item => ({
    ...item,
    quantity: item.quantity || 1,
  }));
 
  addMultipleToCart(itemsToAdd);
 
  // Optional: clear wishlist after adding
  clearwishlist();
 
  navigate("/cart"); // Redirect to cart page
};
 
 
 
 
  useEffect(() => {
    // Load wishlist items on component mount (only from localStorage)
    setWishlistItems(wishlist || []);
 
    // Listen for wishlist updates (in case other components modify it)
    const handleWishlistUpdate = () => {
      setWishlistItems(wishlist || []);
    };
 
    window.addEventListener('wishlistUpdated', handleWishlistUpdate);
 
    return () => {
      window.removeEventListener('wishlistUpdated', handleWishlistUpdate);
    };
  }, []);
 
  // Sort wishlist items
  const sortedItems = React.useMemo(() => {
    const sorted = [...wishlist];
    switch (sortBy) {
      case 'price-low':
        return sorted.sort((a, b) => {
          const priceA = parseFloat(a.price.replace(/[^0-9.]/g, '')) || 0;
          const priceB = parseFloat(b.price.replace(/[^0-9.]/g, '')) || 0;
          return priceA - priceB;
        });
      case 'price-high':
        console.log('Sorting by price high to low');
        console.log('Before sorting:', sorted);
       
        return sorted.sort((a, b) => {
          const priceA = parseFloat(a.price.replace(/[^0-9.]/g, '')) || 0;
          const priceB = parseFloat(b.price.replace(/[^0-9.]/g, '')) || 0;
          return priceB - priceA;
        });
      case 'name':
        return sorted.sort((a, b) => a.name.localeCompare(b.name));
      case 'newest':
      default:
        return sorted.reverse();
    }
  }, [wishlist, sortBy]);
 
  const handleClearWishlist = () => {
    //clearWishlist();
    clearwishlist();
    setWishlistItems(wishlist || []);
    window.dispatchEvent(new CustomEvent('wishlistUpdated'));
  };
 
  // Updated breadcrumb items to use 'path' instead of 'href' for consistency
  const breadcrumbItems = [
    { label: 'Home', path: '/', current: false },
    { label: 'Wishlist', path: '/wishlist', current: true }
  ];
 
  const EmptyWishlist = () => (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="mb-6">
        <Heart size={80} className="text-gray-300 mx-auto" strokeWidth={1} />
      </div>
      <h2 className="text-2xl font-semibold text-neutral-700 mb-4">Your Wishlist is Empty</h2>
      <p className="text-neutral-500 mb-8 max-w-md">
        Save your favorite items to your wishlist and shop them later.
        Start browsing our collection to find products you love!
      </p>
      <button
        onClick={() => navigate('/products')}
        className="inline-flex items-center gap-2 px-6 py-3 bg-yellow-500 text-white font-medium rounded-lg hover:bg-yellow-600 transition-colors duration-200"
      >
        <ShoppingBag size={20} />
        Continue Shopping
      </button>
    </div>
  );
 
 
  return (
    <div className="min-h-screen bg-white">
      <Header />
      {/* <CategoryNav /> */}
 
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Breadcrumb */}
        <div className="mb-8">
          <Breadcrumb items={breadcrumbItems} />
        </div>
 
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-neutral-900 mb-2">My Wishlist</h1>
          <p className="text-neutral-600">
            {wishlist.length === 0
              ? 'No items in your wishlist'
              : `${wishlist.length} item${wishlist.length !== 1 ? 's' : ''} saved`
            }
          </p>
        </div>
 
        {wishlistItems.length === 0 ? (
          <EmptyWishlist />
        ) : (
          <>
            {/* Controls */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-8 pb-6 border-b border-gray-200">
              <div className="flex items-center gap-4">
                <button
                  onClick={handleClearWishlist}
                  className="text-sm text-red-600 hover:text-red-700 font-medium transition-colors duration-200"
                  aria-label="Clear all items from wishlist"
                >
                  Clear All
                </button>
              </div>
 
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium text-neutral-700 whitespace-nowrap">
                  Sort By:
                </label>
                <select
                  className="text-sm font-medium text-yellow-600 bg-white border border-gray-300 rounded px-3 py-1 pr-8 outline-none focus:border-yellow-500"
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                >
                  <option value="newest">Recently Added</option>
                  <option value="name">Name A-Z</option>
                  <option value="price-low">Price: Low to High</option>
                  <option value="price-high">Price: High to Low</option>
                </select>
              </div>
            </div>
 
 
            {/* Products Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {sortedItems.map((product) => (
                <div key={product.id} className="w-full">
                  <ProductCard product={product} showRemoveButton={true} />
                </div>
              ))}
            </div>
 
            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12 pt-8 border-t border-gray-200">
              <button
                onClick={() => navigate('/products')}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white border border-gray-300 text-neutral-700 font-medium rounded-lg hover:bg-gray-50 transition-colors duration-200"
              >
                Continue Shopping
              </button>
              <button
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-yellow-500 text-white font-medium rounded-lg hover:bg-yellow-600 transition-colors duration-200"
                onClick={handleAddAllToCart}
              >
                <ShoppingBag size={20} />
                Add All to Cart
              </button>
            </div>
          </>
        )}
      </main>
 
      <Footer />
    </div>
  );
};
 
export default Wishlist;